import DownFile from './DownFile';
export default DownFile;